export enum FeatureType {
    CountUser = 'CountUser',
    Systems = 'Systems',
    Pages = 'Pages',
    Moduls = 'Moduls',
    CountBrunch = 'CountBrunch',
    StoreCount = 'StoreCount',
    EmployeeCount = 'EmployeeCount',
    CustomerCount = 'CustomerCount',
    VendorCount = 'VendorCount',
    BoxCount = 'BoxCount',
    BankCount = 'BankCount',
    Updates = 'Updates',
    Storage = 'Storage',
    TechnicalSupport = 'TechnicalSupport',
    Analytics = 'Analytics',
    Training = 'Training',
    Service = 'Service',
}

export const FeatureTypeTranslations: Record<FeatureType, string> = {
    [FeatureType.CountUser]: 'عدد المستخدمين',
    [FeatureType.Systems]: 'الأنظمة',
    [FeatureType.Pages]: 'الصفحات',
    [FeatureType.Moduls]: 'الوحدات',
    [FeatureType.CountBrunch]: 'عدد الفروع',
    [FeatureType.StoreCount]: 'عدد المخازن',
    [FeatureType.EmployeeCount]: 'عدد الموظفين',
    [FeatureType.CustomerCount]: 'عدد العملاء',
    [FeatureType.VendorCount]: 'عدد الموردين',
    [FeatureType.BoxCount]: 'عدد الصناديق',
    [FeatureType.BankCount]: 'عدد البنوك',
    [FeatureType.Updates]: 'التحديثات',
    [FeatureType.Storage]: 'التخزين',
    [FeatureType.TechnicalSupport]: 'الدعم الفني',
    [FeatureType.Analytics]: 'التحليلات',
    [FeatureType.Training]: 'التدريب',
    [FeatureType.Service]: 'الخدمة',
};
